"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.FieldType = exports.SiteType = exports.ContentVariant = void 0;
var ContentVariant;
(function (ContentVariant) {
    ContentVariant["BLOCK"] = "BLOCK";
    ContentVariant["PAGE"] = "PAGE";
    ContentVariant["SECTION"] = "SECTION";
    ContentVariant["NAVIGATION"] = "NAVIGATION";
})(ContentVariant = exports.ContentVariant || (exports.ContentVariant = {}));
var SiteType;
(function (SiteType) {
    SiteType["LEGALSHIELD_US"] = "LEGALSHIELD_US";
    SiteType["IDSHIELD_US"] = "IDSHIELD_US";
    SiteType["ALL"] = "ALL";
})(SiteType = exports.SiteType || (exports.SiteType = {}));
var FieldType;
(function (FieldType) {
    FieldType["BOOLEAN"] = "BOOLEAN";
    FieldType["NUMBER"] = "NUMBER";
    FieldType["RESOURCE"] = "RESOURCE";
    FieldType["RESOURCE_ARRAY"] = "RESOURCE_ARRAY";
    FieldType["RICH_TEXT"] = "RICH_TEXT";
    FieldType["TEXT"] = "TEXT";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://content-entries.api.legalshieldinternal.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Fedux ContentEntry Service API
 * @version v1
 * @baseUrl https://content-entries.api.legalshieldinternal.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesCreateContentEntry
             * @request POST:/v1/contentEntries
             * @secure
             */
            contentEntriesCreateContentEntry: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesGetContentEntries
             * @request GET:/v1/contentEntries
             * @secure
             */
            contentEntriesGetContentEntries: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesGetContentEntry
             * @request GET:/v1/contentEntries/{contentEntryId}
             * @secure
             */
            contentEntriesGetContentEntry: (contentEntryId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries/${contentEntryId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesDeleteContentEntry
             * @request DELETE:/v1/contentEntries/{contentEntryId}
             * @secure
             */
            contentEntriesDeleteContentEntry: (contentEntryId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries/${contentEntryId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesUpdateArrayField
             * @request POST:/v1/contentEntries/{contentEntryId}/updateArrayField
             * @secure
             */
            contentEntriesUpdateArrayField: (contentEntryId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries/${contentEntryId}/updateArrayField`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesUpdateContentEntryField
             * @request POST:/v1/contentEntries/{contentEntryId}/updateContentEntryField
             * @secure
             */
            contentEntriesUpdateContentEntryField: (contentEntryId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries/${contentEntryId}/updateContentEntryField`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesUpdateTextField
             * @request POST:/v1/contentEntries/{contentEntryId}/updateTextField
             * @secure
             */
            contentEntriesUpdateTextField: (contentEntryId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries/${contentEntryId}/updateTextField`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentEntries
             * @name ContentEntriesUpdateBooleanField
             * @request POST:/v1/contentEntries/{contentEntryId}/updateBooleanField
             * @secure
             */
            contentEntriesUpdateBooleanField: (contentEntryId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentEntries/${contentEntryId}/updateBooleanField`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentTypes
             * @name ContentTypesGetContentTypes
             * @request GET:/v1/contentTypes
             * @secure
             */
            contentTypesGetContentTypes: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentTypes`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ContentTypes
             * @name ContentTypesGetContentType
             * @request GET:/v1/contentTypes/{contentTypeId}
             * @secure
             */
            contentTypesGetContentType: (contentTypeId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/contentTypes/${contentTypeId}`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=content-entries.js.map